import type { FindingOut } from '@/api/types';

// The synthetic "engine reviewed this transaction and found no recoverable
// issue" finding, auto-rejected at $0, written for every transaction that
// matched no rule so the findings table covers the full transaction
// population (INP-684). These are coverage rows, not practitioner-reviewable
// findings, so the review surfaces hide them by default.
export const NO_ISSUE_CATEGORY = 'no_issue_detected';

export function isAutoCleared(f: Pick<FindingOut, 'category'>): boolean {
  return f.category === NO_ISSUE_CATEGORY;
}

/** Drop the auto-cleared coverage rows — the default view for the review
 *  surfaces (queue / list / audit / supplier + GL rollups). */
export function excludeAutoCleared(findings: readonly FindingOut[]): FindingOut[] {
  return findings.filter((f) => !isAutoCleared(f));
}

/** How many of these findings are auto-cleared coverage rows. */
export function countAutoCleared(findings: readonly FindingOut[]): number {
  return findings.reduce((n, f) => (isAutoCleared(f) ? n + 1 : n), 0);
}
